import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllSupplementDetails } from "../redux/supplement-details";
import SupplementCard from "../components/EnhanceSailing/SupplementCard";
import Loader from "../components/Loader";
import { itineraryWiseAddonEnabled } from "../utils/helperFunctions/supplements";

const EnhanceSailing = ({ bookingDetails }) => {
  const { cruise_id, sailing_date } = bookingDetails;
  const dispatch = useDispatch();
  const [categoryTabs, setCategoryTabs] = useState([]);
  const [currentTab, setCurrentTab] = useState("All enhancements");

  const allSupplementDetails = useSelector(
    (state) => state.allSupplementDetails.supplements
  );
  const isLoading = useSelector(
    (state) => state.allSupplementDetails.isLoading
  );

  const groupedSupplements = useMemo(() => {
    let supplements = {};

    allSupplementDetails
      .filter((item) =>
        itineraryWiseAddonEnabled(
          item.itinerary_ids,
          bookingDetails.itinerary_title
        )
      )
      .forEach((item) => {
        if (!supplements[item.title]) {
          supplements[item.title] = {
            ...item,
            child: {},
          };
        }
        if (item.product_name.includes("Child")) {
          supplements[item.title].child = {
            ...item,
          };
        }
      });

    return supplements;
  }, [allSupplementDetails, bookingDetails]);

  const combinedSupplements = useMemo(
    () => Object.values(groupedSupplements),
    [groupedSupplements]
  );

  // Extract the function to calculate category tabs
  const calculateCategoryTabs = (supplements) => {
    const categoryTitles = supplements?.map((item) => item.category_title);
    return ["All enhancements", ...new Set(categoryTitles)];
  };

  useEffect(() => {
    const newCategoryTabs = calculateCategoryTabs(combinedSupplements);
    if (JSON.stringify(newCategoryTabs) !== JSON.stringify(categoryTabs)) {
      setCategoryTabs(newCategoryTabs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combinedSupplements]);

  useEffect(() => {
    if (cruise_id && sailing_date && allSupplementDetails.length === 0) {
      dispatch(
        getAllSupplementDetails({
          cruise_id,
          sailing_date,
        })
      );
    }
  }, [allSupplementDetails, dispatch, cruise_id, sailing_date, bookingDetails]);

  return (
    <div>
      <div className="md:w-3/4 mx-auto p-4 md:p-8">
        <div>
          <h1 className="text-2xl text-center uppercase text-mv-darkblue  font-bold">
            Enhance Sailing
          </h1>
        </div>
        <div
          className="flex overflow-x-auto gap-4
         justify-around md:overflow-auto text-xl py-4 mt-4 px-10 font-semibold"
        >
          {categoryTabs?.map((category) => (
            <div
              key={category}
              className={`cursor-pointer text-nowrap ${
                currentTab === category
                  ? "underline font-bold text-mv-darkblue"
                  : "text-[#6699C2]"
              }`}
              onClick={() => setCurrentTab(category)}
            >
              {category}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 mt-4 gap-5">
          {combinedSupplements
            .filter((supplement) =>
              currentTab === "All enhancements"
                ? true
                : currentTab === supplement.category_title
            )
            .map((supplement) => (
              <SupplementCard key={supplement.title} supplement={supplement} />
            ))}
        </div>
      </div>
      <Loader isLoading={isLoading} />
    </div>
  );
};

export default EnhanceSailing;
